"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var retry = function retry(getPromise) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  opts.max = opts.max || 5;
  opts.backoff = opts.backoff || 1000;
  return new Promise(function (resolve, reject) {
    var attempt = function attempt(i) {
      return getPromise(i).then(function (res) {
        if (res.status.toString().match(/^5\d+/)) {
          if (i >= opts.max) {
            return resolve(res);
          }
          setTimeout(function () {
            return attempt(i + 1);
          }, i * opts.backoff);
        } else {
          return resolve(res);
        }
        return resolve;
      }).catch(function (err) {
        if (i >= opts.max) {
          return reject(err);
        }
        setTimeout(function () {
          return attempt(i + 1);
        }, i * opts.backoff);
      });
    };
    attempt(1);
  });
};
exports.default = retry;